import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ReactPlayer from 'react-player';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

export default function VideoComponent() {
  const classes = useStyles();

  function FormRow() {
    return (
      <>
        <Grid item xs={4}>
          <ReactPlayer url="https://www.facebook.com/StevenUniverse/videos/250622326409257" width="auto" style={{ width: 'auto', height: 'auto', padding: '5px' }} />
        </Grid>
        <Grid item xs={4}>
          <ReactPlayer url="https://www.youtube.com/watch?v=ysz5S6PUM-U" width="auto" style={{ width: 'auto', height: 'auto', padding: '5px' }} />
        </Grid>
        <Grid item xs={4}>
          <ReactPlayer url="https://www.youtube.com/watch?v=ysz5S6PUM-U" width="auto" style={{ width: 'auto', height: 'auto', padding: '5px' }} />
        </Grid>
      </>
    );
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid container item xs={12} spacing={0}>
          <FormRow />
        </Grid>

      </Grid>
    </div>
  );
}
